export const MIN_HOVER_AREA_HEIGHT = 20;

// Calculate box dimensions with optional minimum height for hit areas
export const getBoxDimensions = (
  d: any,
  continuousScale: any,
  minHeight = 0,
) => {
  const top = continuousScale.scale(d.stats.q3);
  const bottom = continuousScale.scale(d.stats.q1);
  const calculatedHeight = bottom - top;

  if (minHeight > 0 && calculatedHeight < minHeight) {
    const center = (top + bottom) / 2;
    return {
      y: center - minHeight / 2,
      height: minHeight,
    };
  }

  return { y: top, height: calculatedHeight };
};
